// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"e1fe83b0","221":"58311523","239":"ac953f03","732":"ebb2dad4","977":"49756be5"}[chunkId] + ".chunk.js";
};